import {isValidElement} from 'react';
import {renderToString} from 'react-dom/server';

export const renderReactComponentsToString = (replacements) => {
    const transRepls = {};

    for (const name in replacements) {
        const elm = replacements[name];
        transRepls[name] = isValidElement(elm) ? renderToString(elm) : elm;
    }

    return transRepls;
};